export default __webpack_public_path__ + "images/bottle-stone-2.svg";